export default __webpack_public_path__ + "static/media/54.66d64ee6.jpg";